import {
  // isPermissionAdminOrGreater,
  // isPermissionMaster,
} from 'utils/validators'

// import AdminOrganization from 'ui/views/admin/Organization'
// import AdminOrganizationPlanCpf from 'ui/views/admin/OrganizationPlanCpf'
// import AdminOrganizationPlanCnpj from 'ui/views/admin/OrganizationPlanCnpj'

import ConfigUser from 'ui/views/config/User'
import ConfigUsers from 'ui/views/config/Users'

import DocsConsult from 'ui/views/docs/Consult'
import DocsGovBr from 'ui/views/docs/GovBr'
import DocsIntroduction from 'ui/views/docs/Introduction'
import DocsPlan from 'ui/views/docs/Plan'
import DocsReport from 'ui/views/docs/Report'
import DocsServices from 'ui/views/docs/Services'
import DocsUsers from 'ui/views/docs/Users'

// import MasterOrganizations from 'ui/views/master/Organizations'

const ADMIN_PATHS = {
  // BV: nao tem essa funcionalidade
  // ORGANIZATION: {
  //   NAME: 'Minha Organização',
  //   PATH: '/admin/organization',
  //   COMPONENT: AdminOrganization,
  //   FUNC_PERMISSION: isPermissionAdminOrGreater,
  // },
  // ORGANIZATION_PLAN_CPF: {
  //   NAME: 'Organização - Plano do CPF',
  //   PATH: '/admin/organization-plan-cpf',
  //   COMPONENT: AdminOrganizationPlanCpf,
  //   FUNC_PERMISSION: isPermissionAdminOrGreater,
  // },
  // ORGANIZATION_PLAN_CNPJ: {
  //   NAME: 'Organização - Plano do CNPJ',
  //   PATH: '/admin/organization-plan-cnpj',
  //   COMPONENT: AdminOrganizationPlanCnpj,
  //   FUNC_PERMISSION: isPermissionAdminOrGreater,
  // },
}

const CONFIG_PATHS = {
  USER: {
    NAME: 'Meu Usuário',
    PATH: '/config/user',
    COMPONENT: ConfigUser,
  },
  USERS: {
    NAME: 'Usuários',
    PATH: '/config/users',
    COMPONENT: ConfigUsers,
  },
}

const DOC_PATHS = {
  INTRODUCTION: {
    NAME: 'Introdução',
    PATH: '/docs/introduction',
    COMPONENT: DocsIntroduction,
  },
  USERS: {
    NAME: 'Usuários',
    PATH: '/docs/users',
    COMPONENT: DocsUsers,
  },
  CONSULT: {
    NAME: 'Consulta',
    PATH: '/docs/consult',
    COMPONENT: DocsConsult,
  },
  PLAN: {
    NAME: 'Plano',
    PATH: '/docs/plan',
    COMPONENT: DocsPlan,
  },
  REPORT: {
    NAME: 'Relatório',
    PATH: '/docs/report',
    COMPONENT: DocsReport,
  },
  SERVICES: {
    NAME: 'Serviços',
    PATH: '/docs/services',
    COMPONENT: DocsServices,
  },
  GOV_BR: {
    NAME: 'Configuração GOV.BR',
    PATH: '/docs/govbr',
    COMPONENT: DocsGovBr,
  },
}

const MASTER_PATHS = {
  // BV: nao tem essa funcionalidade
  // ORGANIZATIONS: {
  //   NAME: 'Organizações',
  //   PATH: '/master/organizations',
  //   COMPONENT: MasterOrganizations,
  //   FUNC_PERMISSION: isPermissionMaster,
  // },
}

export {
  ADMIN_PATHS,
  CONFIG_PATHS,
  DOC_PATHS,
  MASTER_PATHS,
}
